/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Overview } from "./renderPages/Overview";
import { Discussion } from "./renderPages/Discussion";
import { RecommenedCourse } from "./RecommendCourse";
import { Faq } from "./renderPages/Faq";
import { Review } from "./renderPages/Review";
import BreadTag from "components/dashboard/home/BreadTag";
import Button from "components/dashboard/forms/button/Button";
import lessonIcon from "../../../../../../assets/images/lessonIcon.png";
import radio1 from "../../../../../../assets/images/radio1.png";
import radio2 from "../../../../../../assets/images/radio2.png";
import radio3 from "../../../../../../assets/images/radio3.png";
import { CourseServices } from "services/courses";
import { Icon } from "@iconify/react";
import axios from "axios";

const CourseDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { courseData } = location.state || {}; // Retrieve the passed data
  const courseId = courseData.course.id;

  const [selectedVideo, setSelectedVideo] = useState(""); // Track selected video

  const [activePage, setActivePage] = useState("overview");
  const videoRef = useRef(null);
  const progressRef = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const [progress, setProgress] = useState(0);
  // console.log(progress);
  const [lessonProgress, setLessonProgress] = useState({});
  const [activeLesson, setActiveLesson] = useState(null); // Track active lesson
  const statuses = ["overview", "faq", "discussion", "review"];
  // eslint-disable-next-line no-unused-vars
  const [Loading, setLoading] = useState(false);
  const [lessonData, setLessonData] = useState([]);
  const token = JSON.parse(sessionStorage.getItem("token") || "{}");

  useEffect(() => {
    getSingleCourse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    sendProgressToBackend();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getSingleCourse = async () => {
    setLoading(true);
    try {
      const response = await CourseServices.fetchSingleCourses(courseId);
      console.log("fetch single courses", response);
      if (response.data.status === "success") {
        const res = response.data.data.details.lessons;
        // console.log("lesson", res);
        setLessonData(res);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  // Dynamically assigning labels to lessons
  const labeledLessons = lessonData.map((lesson, index) => ({
    ...lesson,
    label: `Lesson ${index + 1}`,
  }));
  // console.log("label", labeledLessons);

  // Function to render the active component
  const renderPage = () => {
    switch (activePage) {
      case "overview":
        return <Overview data={courseData} />;
      case "discussion":
        return <Discussion />;
      case "review":
        return <Review />;
      case "faq":
        return <Faq />;
      default:
        return <Overview />;
    }
  };

  const recomendCourse = [
    {
      id: 1,
      img: radio1,
      name: "Emerging Technologies in Auto Repair",
      category: "Tech",
    },
    {
      id: 2,
      img: radio2,
      name: "Techniques in the Modern World in Clothing and Texiles",
      category: "Artisans",
    },
    {
      id: 3,
      img: radio3,
      name: "Sustainable Livestock Management Practices",
      category: "Artisans",
    },
  ];

  // console.log("course data", courseData);

  const downloadPDF = async (url) => {
    try {
      const response = await axios({
        url,
        method: "GET",
        responseType: "blob", // Important for handling binary data
      });

      // Create a link element, point to the blob, and programmatically click it
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      // Open the PDF in a new tab
      // window.open(downloadUrl, '_blank');
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "downloaded_file.pdf"); // Set the file name

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up link after download
      console.log("Download successful.");
    } catch (error) {
      console.error("Failed to download:", error);
    }
  };

  const [currentVideoId, setCurrentVideoId] = useState(null); // Track the active video

  // Function to send progress to backend
  const sendProgressToBackend = async (progressRate) => {
    const safeProgressRate = progressRate ? progressRate.toString() : "0";
    const data = { progressRate: safeProgressRate };
    const lessonId = activeLesson;
  
    try {
      const response = await CourseServices.updateLessonTrack(token, data, lessonId);
      console.log("Updated lesson track", response);
      if (response.data.status === "success") {
        console.log("Updated successfully");
      }
    } catch (error) {
      console.log("Error updating lesson track:", error);
    }
  };
  
  // Handle progress tracking
  const handleProgress = () => {
    if (videoRef.current) {
      const currentTime = videoRef.current.currentTime || 0;
      const duration = videoRef.current.duration || 1;
      const progressPercentage = (currentTime / duration) * 100;
  
      setLessonProgress((prevData) => ({
        ...prevData,
        [activeLesson]: progressPercentage,
      }));
  
      console.log(`Tracking progress for lesson: ${activeLesson}`);
      console.log(`Current progress: ${progressPercentage.toFixed(2)}%`);
    }
  };
  
  // Handle pause event
  const handlePause = () => {
    if (videoRef.current && currentVideoId === activeLesson) {
      handleProgress(); // Update local progress
      const currentTime = videoRef.current.currentTime || 0;
      const duration = videoRef.current.duration || 1;
      const progressPercentage = ((currentTime / duration) * 100).toFixed(2);
  
      console.log("Video paused, sending progress to backend");
      sendProgressToBackend(progressPercentage); // Ensure valid value
    }
  };
  
  // Handle video ended event
  const handleEnded = () => {
    if (videoRef.current && currentVideoId === activeLesson) {
      console.log("Video ended, sending progress to backend");
      sendProgressToBackend("100"); // Send as string
    }
  };
  
  // Handle user leaving
  const handleLeave = () => {
    if (videoRef.current && currentVideoId === activeLesson) {
      handleProgress(); // Update local progress
      const currentTime = videoRef.current.currentTime || 0;
      const duration = videoRef.current.duration || 1;
      const progressPercentage = ((currentTime / duration) * 100).toFixed(2);
  
      console.log("User left the video, sending progress to backend");
      sendProgressToBackend(progressPercentage); // Ensure valid value
    }
  };
  
  // Handle visibility change for when the user navigates away
  const handleVisibilityChange = () => {
    if (document.hidden) {
      handleLeave(); // Track when the user leaves or minimizes the page
    }
  };
  
  // Setup event listeners for pause, ended, and visibility change
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener("pause", handlePause);
      videoRef.current.addEventListener("ended", handleEnded);
    }
  
    // Handle page visibility changes
    document.addEventListener("visibilitychange", handleVisibilityChange);
  
    return () => {
      if (videoRef.current) {
        videoRef.current.removeEventListener("pause", handlePause);
        videoRef.current.removeEventListener("ended", handleEnded);
      }
  
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [currentVideoId, activeLesson]);
  
  // Update current video when a new video is selected
  useEffect(() => {
    if (activeLesson) {
      setCurrentVideoId(activeLesson); // Update the current active video
      if (videoRef.current) {
        videoRef.current.currentTime = 0; // Reset video time for new video
      }
    }
  }, [activeLesson]);
  

  const handleLessonClick = (lesson) => {
    setSelectedVideo(lesson.videoUrl);
    setActiveLesson(lesson.id);
  };

  const handleNextSession = () => {
    const nextIndex =
      labeledLessons.findIndex((l) => l.id === activeLesson) + 1;
    if (nextIndex < labeledLessons.length) {
      handleLessonClick(labeledLessons[nextIndex]);
    }
  };

  const handleBackSession = () => {
    const prevIndex =
      labeledLessons.findIndex((l) => l.id === activeLesson) - 1;
    if (prevIndex >= 0) {
      handleLessonClick(labeledLessons[prevIndex]);
    }
  };

  return (
    <div className="p-6 bg-gray-100 flex-1 overflow-auto">
      <BreadTag
        item1={"Dashboard"}
        item2={"My Courses"}
        item3={"Full Details"}
        onClick1={() => navigate("../home")}
        onClick2={() => navigate("../my-courses")}
      />
      <main className="flex lg:flex-row flex-col w-full gap-6 ">
        <div className="lg:w-[70%] w-full">
          <div className="flex flex-col gap-6 w-full ">
            {/* Video Section */}
            <div className="w-full h-[284px]">
              <div className="relative w-full h-full">
                <video
                  className="w-full h-full object-cover rounded-lg shadow-lg"
                  ref={videoRef}
                  onTimeUpdate={handleProgress}
                  key={selectedVideo}
                  controls
                >
                  <source
                    src={
                      selectedVideo ||
                      // "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                      ""
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
                {/* progress bar */}
                {/* <div
                  className="w-full h-[6px] bg-gray-200 mt-2"
                  onClick={handleSeek}
                  ref={progressRef}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="h-full bg-blue-500"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div> */}
                {/* <div>
                  <p className="text-right text-sm text-blueColor">
                    {progress.toFixed(2)}% Completed
                  </p>
                </div> */}
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <h2 className="text-blueColor font-ManropeBold md:text-[22px] leading-[24px]">
                {courseData.course.title}
              </h2>
              <div className="flex gap-4 items-center">
                <h1>By {courseData.course.tutor}</h1>
                <span className="w-[1px] h-6 bg-black"></span>
                <h1> {courseData.course.subCategory}</h1>
              </div>
            </div>
            <div className="flex flex-col">
              <div className="flex gap-12 py-4 font-semibold items-center text-sm">
                {statuses.map((status) => (
                  <button
                    className={` py-2 md:text-[20px] font-ManropeLight leading-[24px] text-neutral pb-[4px] capitalize  ${
                      status === activePage
                        ? "border-b-primary border-b-4 transition-all text-primary duration-100"
                        : ""
                    }`}
                    key={status}
                    onClick={() => setActivePage(status)}
                  >
                    {status}
                  </button>
                ))}
              </div>
              {renderPage()}
            </div>
          </div>
        </div>

        <div className="lg:w-[30%] flex-col flex lg:gap-12 gap-6 ">
          <section className="w-full lg:h-[459px] bg-white flex flex-col justify-between">
            <div className="p-6 overflow-auto flex flex-col gap-6 flex-grow">
              {labeledLessons.map((lesson) => (
                <div
                  key={lesson.id}
                  className="flex gap-2 items-center cursor-pointer"
                  onClick={() => handleLessonClick(lesson)}
                >
                  <img src={lessonIcon} alt="lesson-icon" className="h-10" />
                  <div className="flex flex-col justify-between">
                    <h2 className="text-blueColor">{lesson.label}</h2>
                    <div className="flex items-center gap-2">
                      {/* Check if lesson contains a PDF document */}

                      {lesson.fileUrl && (
                        <Icon
                          icon="fluent:document-pdf-32-regular"
                          className="text-red-600"
                          width="20"
                          height="20"
                          onClick={() => downloadPDF(lesson.fileUrl)}
                        />
                        // </a>
                      )}

                      <p
                        className={`text-[12px] font-ManropeSemibold ${
                          activeLesson === lesson.id
                            ? "text-primary"
                            : "text-[#9CA3AF]"
                        }`}
                      >
                        {lesson.title}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

              {/* {labeledLessons.map((lesson) => (
                <div key={lesson.id} className="flex gap-2  items-center cursor-pointer" onClick={()=> handleLessonClick(lesson)}>
                  <img src={lessonIcon} alt="lesson-icon" className="h-10" />
                  <div className="flex flex-col justify-between">
                    <h2 className="text-blueColor">{lesson.label}</h2>
                    <p
                      className={`text-[12px] font-ManropeSemibold ${
                        activeLesson === lesson.id
                          ? "text-primary"
                          : "text-[#9CA3AF]"
                      }`}
                    >
                      {lesson.title}
                    </p>

                  </div>
                </div>
              ))} */}
            </div>

            {/* Fixed Bottom Button */}
            <div className="w-full bg-[#D2D5DA] py-3 px-6 gap-2 flex justify-between">
              <Button onClick={handleBackSession}>Back</Button>
              <Button onClick={handleNextSession}>Next Session</Button>
            </div>
          </section>
          <section className=" w-full">
            <RecommenedCourse data={recomendCourse} />
          </section>
        </div>
      </main>
    </div>
  );
};
export default CourseDetails;